import { create } from 'zustand';
import { adminOrderApi } from '@api/api-config.ts';
import { AdminOrderDetailDTO } from '@api/generated/portal-be-admin';

interface AdminOrderDetailStoreState {
  loading: boolean;
  error: string | null;
  order: AdminOrderDetailDTO | null;
  loadOrderDetail: (orderId: number) => Promise<void>;
  clear: () => void;
}

export const useAdminOrderDetailStore = create<AdminOrderDetailStoreState>(set => ({
  loading: false,
  error: null,
  order: null,

  loadOrderDetail: async (orderId: number) => {
    try {
      set({ loading: true, error: null });
      const response = await adminOrderApi.getOrderDetail({ orderId });
      set({
        loading: false,
        error: null,
        order: response.data,
      });
    } catch (error) {
      set({
        loading: false,
        error: error instanceof Error ? error.message : 'Chyba při načítání detailu objednávky',
        order: null,
      });
    }
  },

  clear: () => {
    set({ loading: false, error: null, order: null });
  },
}));
